import * as Inflected from 'inflected';

/**
 * Returns the singular or plural version of a string based on count.
 *
 * @param {number} count
 * @param {string} string
 * @param {string} [locale]
 *
 * @returns {string}
 */
export default function pluralize(count, string, locale) {
  return count === 1 ? string : Inflected.pluralize(string, locale);
}
